import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { ClientStorageService } from 'src/app/services/client-storage.service';
import { ScholasticYear } from 'src/app/models/scholastic-year.model';
import { DepartmentUtils } from 'src/app/models/department.model';
import { UtilityService } from 'src/app/services/utility.service';
import { Component, inject, OnInit } from '@angular/core';
import { API } from 'src/app/constants/api';

@Component({
  selector: 'app-utility',
  templateUrl: './utility.component.html',
  styleUrls: ['./utility.component.scss'],
})
export class UtilityComponent implements OnInit {
  private _utilityService: UtilityService = inject(UtilityService);
  private _baseComponentService = inject(BaseComponentService);
  private _clientStorageService = inject(ClientStorageService);

  public fieldListing = [
    { fe: 'Nome', be: 'nome' },
    { fe: 'Secondo Nome', be: 'secondo_nome' },
    { fe: 'Cognome', be: 'cognome' },
    { fe: 'Codice Fiscale', be: 'codice_fiscale' },
    { fe: 'Sesso', be: 'sesso' },
    { fe: 'Luogo Di Nascita', be: 'luogo_di_nascita' },
    { fe: 'Provincia Di Nascita', be: 'provincia_di_nascita' },
    { fe: 'Nazionalita', be: 'nazionalita' },
    { fe: 'Indirizzo (Domicilio)', be: 'domicilio.indirizzo' },
    { fe: 'Civico (Domicilio)', be: 'domicilio.civico' },
    { fe: 'CAP (Domicilio)', be: 'domicilio.cap' },
    { fe: 'Citta (Domicilio)', be: 'domicilio.citta' },
    { fe: 'Provincia (Domicilio)', be: 'domicilio.provincia' },
    { fe: 'Indirizzo (Residenza)', be: 'residenza.indirizzo' },
    { fe: 'Civico (Residenza)', be: 'residenza.civico' },
    { fe: 'CAP (Residenza)', be: 'residenza.cap' },
    { fe: 'Citta (Residenza)', be: 'residenza.citta' },
    { fe: 'Provincia (Residenza)', be: 'residenza.provincia' },
    { fe: 'Indirizzo E-Mail', be: 'contatti.email.indirizzo' },
    { fe: 'Numero di Telefono', be: 'contatti.telefono.numero' },
  ];
  public departmentsListing: string[] = DepartmentUtils.getDepartmentsStrings();
  public anno_scolastico: string = ScholasticYear.getCurrent();
  public headquarter: string = this._clientStorageService
    .getHeadquarterString()
    .toUpperCase();
  public scholasticYears: string[] = [];
  public departments: string[] = [];
  public type: string = 'Student';
  public sections: string[] = [];
  public features: string[] = [];
  public fields: string[] = [];
  public years: string[] = [];
  public text: string = '';

  public additionalFields: string[] = [];

  public textInputTimer: any;

  public number: number = 0;
  public getting: boolean = false;

  get parameters() {
    return {
      type: this.type,
      y: this.anno_scolastico,
      years: this.years.join(','),
      sections: this.sections.join(','),
      departments: this.departments.join(','),
      features: this.features.join(','),
      text: this.text,
      fields: this.fields.join(','),
      additionalFields: this.additionalFields.join(','),
    };
  }

  ngOnInit(): void {
    this._utilityService
      .getScholasticYears()
      .subscribe({
        next: (response) => (this.scholasticYears = response.data),
        error: (error: unknown) => console.error('ERROR:', error),
      })
      .add(() => this.getNumber());
  }

  setUserType(event: any) {
    this.type = event.value;
    if (this.type != 'Student') this.features = [];
    this.getNumber();
  }

  isUserType(type: string): boolean {
    return this.type === type;
  }

  onText(event: any) {
    this.text = event.target.value;
    if (this.textInputTimer) clearTimeout(this.textInputTimer);
    this.textInputTimer = setTimeout(() => this.getNumber(), 1000);
  }

  onCheckboxChanged(param: string, value: string) {
    if (param == 'years') {
      if (this.years.includes(value)) {
        this.years.splice(this.years.indexOf(value), 1);
      } else this.years.push(value);
    } else if (param == 'sections') {
      if (this.sections.includes(value)) {
        this.sections.splice(this.sections.indexOf(value), 1);
      } else this.sections.push(value);
    } else if (param == 'departments') {
      if (this.departments.includes(value)) {
        this.departments.splice(this.departments.indexOf(value), 1);
      } else this.departments.push(value);
    } else if (param == 'fields') {
      if (this.fields.includes(value)) {
        this.fields.splice(this.fields.indexOf(value), 1);
      } else this.fields.push(value);
    } else if (param == 'features') {
      if (this.features.includes(value)) {
        this.features.splice(this.features.indexOf(value), 1);
      } else this.features.push(value);
    } else if (param == 'additional-fields') {
      if (this.additionalFields.includes(value)) {
        this.additionalFields.splice(this.additionalFields.indexOf(value), 1);
      } else this.additionalFields.push(value);
    }
    this.getNumber();
  }

  onScholasticYearChange(event: any) {
    this.anno_scolastico = event.target.value;
    this.getNumber();
  }

  async getNumber() {
    this._utilityService.getExportNumberOfItems(this.parameters).subscribe({
      next: (data: any) => {
        this.number = parseInt(data.data) || 0;
      },
      error: (err: any) => {
        console.error('Get Number of Items Error:', err);
        this.number = -1;
      },
    });
  }

  async getData() {
    this.getting = true;
    this._baseComponentService
      .downloadFile({
        url: API.utilityCSV(this.parameters),
        defaultFileName: `${this.formatDateToyyyyMMddhhmmss()} • De Amicis Ring • ${
          this.type
        } ${this.years.join('|')} ${this.departments.join('|')}`,
        withCredentials: true,
      })
      .then((_) => (this.getting = false));
  }

  formatDateToyyyyMMddhhmmss(): string {
    const now = new Date();
    const year = now.getFullYear().toString().padStart(4, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  }
}
